export default __webpack_public_path__ + "static/media/guesty_lite_step8.9c157283.png";